import React, { Component } from "react";
import { TextField, MenuItem, ListItemText } from "@material-ui/core";
import moment from "moment";
import "moment-parseplus";
import Autocomplete from "react-autocomplete";

import "./HubTimepicker.css";

class HubTimepicker extends Component {
    state = {
        value: undefined,
        valueText: undefined,
        duration: "",
        open: false,
        timepickerOpen: false,
        times: []
    };

    componentDidUpdate(prevProps) {
        // console.log("componentDidUpdate", this.props.value, this.props.start);
        if (this.props.value !== prevProps.value) {
            const text = this.props.value ? moment(this.props.value).format("h:mma") : "";
            const duration = this.props.start ? "(" + moment(this.props.value).diff(this.props.start, "hours", true) + " hours)" : "";
            this.setState({ value: this.props.value, valueText: text, duration: duration });
            this.initializeHours();
        }
        // Reinitialize hours when start time changes (for end time pickers)
        if (this.props.start !== prevProps.start) {
            this.initializeHours();
        }
    }

    componentDidMount() {
        this.initializeHours();
        const text = this.props.value ? moment(this.props.value).format("h:mma") : "";
        const duration = this.props.start ? "(" + moment(this.props.value).diff(this.props.start, "hours", true) + " hours)" : "";
        this.setState({ value: this.props.value, valueText: text, duration: duration });
    }

    initializeHours = () => {
        // console.log("initialize hours", this.props.start);
        let times = [];
        const defaultStartHour = this.props.defaultStartHour !== undefined ? this.props.defaultStartHour : 12;
        
        if (this.props.start) {
            const startMoment = moment(this.props.start);
            // When we have a start time, generate full 24 hours of options
            // but reorder so the typical duration (3 hours after start) appears first
            const offsetHours = this.props.defaultOffset !== undefined ? this.props.defaultOffset : 0;
            
            // Generate all 48 half-hour slots (24 hours)
            let allTimes = [];
            for (let i = 0; i < 24; i++) {
                for (let j = 0; j <= 30; j = j + 30) {
                    allTimes.push(
                        moment(startMoment)
                            .add(i, "hour")
                            .minute(startMoment.minute())
                            .add(j, "minutes")
                    );
                }
            }
            
            // If offset specified, reorder so offset hours appears first
            if (offsetHours > 0) {
                const offsetSlots = offsetHours * 2; // 2 slots per hour (30 min intervals)
                times = [...allTimes.slice(offsetSlots), ...allTimes.slice(0, offsetSlots)];
            } else {
                times = allTimes;
            }
        } else {
            // No start time - begin list at defaultStartHour (noon by default)
            // but include all 24 hours by wrapping around
            for (let i = 0; i < 24; i++) {
                const hour = (defaultStartHour + i) % 24;
                for (let j = 0; j <= 30; j = j + 30) {
                    times.push(
                        moment()
                            .hour(hour)
                            .minute(j)
                            .second(0)
                    );
                }
            }
        }
        this.setState({ times: times });
    };

    setOpen = ({ open }) => {
        if (this.props.readOnly) {
            return false;
        }
        this.setState({ timepickerOpen: open });
    };

    handleToggleOpen = event => {
        if (this.props.readOnly) {
            return false;
        }
        this.setState({
            timepickerOpen: !this.state.timepickerOpen
        });
        console.log("togle open");
    };

    handleChange = (e, value) => {
        // this.setState({ open: true });
        // const timeDifference = Math.abs(e.diff(this.props.value));
        // if (timeDifference < moment.duration(1, "hour") && timeDifference >= moment.duration(1, "minute")) {
        //     this.setOpen({ open: false });
        // }
        // console.log("value", e, value);
        this.setState({
            valueText: value,
            open: true
        });

        // this.props.onChange(value);
    };

    calculateDisabledHour = () => {
        const { min } = this.props;
        let disabledHour = [];
        if (min) {
            var minTime = moment(min, "HH:mm");
            var minHour = minTime.hour();
            for (var i = 0; i < minHour; i++) {
                disabledHour.push(i);
            }
        }
        return disabledHour;
    };

    calculateDisabledMinute = () => {
        const { min, value } = this.props;
        let disabledMinutes = [];
        if (min) {
            var minTime = moment(min, "HH:mm");
            var valueTime = moment(value, "HH:mm");
            var minHour = minTime.hour();
            var minHourValue = valueTime.hour();
            if (minHour === minHourValue) {
                var minMinute = minTime.minute();
                for (var i = 0; i < minMinute; i++) {
                    disabledMinutes.push(i);
                }
            }
        }
        return disabledMinutes;
    };

    renderMenu = children => {
        const { menuStyle } = this.props;
        return (
            <div
                className="menu timepicker-menu"
                style={menuStyle ? menuStyle : { position: "absolute", zIndex: "9999", width: "100%", maxHeight: "300px", overflowY: "auto" }}
            >
                {children}
            </div>
        );
    };

    handleOnBlur = e => {
        //console.log("onbluer", e.target.value);

        // we need to do this timeout trick otherwise onblur will close the menu before we can fire onselect
        setTimeout(() => {
            this.setState({
                open: false
            });
        }, 400);

        const inputValue = e.target.value;
        if (!inputValue || inputValue.trim() === "") {
            return;
        }
        
        // If input is empty, reset to current value display
        if (!inputValue || inputValue.trim() === "") {
            const currentText = this.props.value ? moment(this.props.value).format("h:mma") : "";
            this.setState({ valueText: currentText });
            return;
        }

        const currentValueText = this.props.value ? moment(this.props.value).format("h:mma") : "";

        if (inputValue !== currentValueText) {
            // Try parsing the typed input using moment-parseplus for flexible parsing
            let time = moment(inputValue, ["h:mma", "h:mm a", "H:mm", "HH:mm", "h a", "ha", "H"]);
            if (time && time.isValid()) {
                // Use today's date as base if no existing value
                const baseMoment = this.props.value ? moment(this.props.value) : moment();
                const newTime = baseMoment
                    .clone()
                    .hour(time.hour())
                    .minute(time.minute())
                    .second(0);
                this.props.onChange(newTime);
            } else {
                console.log("invalid hour", inputValue);
                // Reset display to current valid value
                const currentText = this.props.value ? moment(this.props.value).format("h:mma") : "";
                this.setState({ valueText: currentText });
                if (this.props.value) {
                    this.props.onChange(this.props.value);
                }
            }
        }
    };

    handleOnFocus = e => {
        //console.log("onfocus", e);
        if (!this.props.readOnly) {
            this.setState({
                open: true
            });
        }
    };

    renderInput = props => {
        const { ref, ...rest } = props;

        return (
            <TextField
                {...rest}
                inputRef={ref}
                // value={this.state.valueText}
                onBlur={this.handleOnBlur}
                onFocus={this.handleOnFocus}
                inputProps={{
                    inputMode: "text",
                    ...rest.inputProps
                }}
                InputProps={{
                    ...rest.InputProps
                }}
                // InputProps={{
                //     endAdornment: this.state.loading ? (
                //         <InputAdornment position="start">
                //             <CircularProgress size={30} />
                //         </InputAdornment>
                //     ) : (
                //         ""
                //     )
                // }}
            />
        );
    };

    renderItem = (item, isHighlighted) => {
        let text = this.props.start
            ? moment(item).format("h:mma") + " (" + moment(item).diff(this.props.start, "hours", true).toFixed(2) + " hours)"
            : moment(item).format("h:mma");

        return (
            <MenuItem
                key={item}
                selected={isHighlighted}
                component="div"
                style={{
                    zIndex: 9999,
                    backgroundColor: isHighlighted ? "#ff0c9c" : "#ffffff"
                }}
            >
                <ListItemText primary={text} />
            </MenuItem>
        );
    };

    getItemValue = item => {
        // return item;
        //  console.log("get item value");
        return moment(item).format("h:mma");
    };

    handleSelect = (value, item) => {
        this.props.onChange(item);
        console.log("value selected", value);
        this.setState({
            open: false
        });
    };
    render() {
        const { label, readOnly } = this.props;
        //console.log("render");
        return (
            <Autocomplete
                items={this.state.times}
                renderInput={this.renderInput}
                renderMenu={this.renderMenu}
                renderItem={this.renderItem}
                getItemValue={this.getItemValue}
                onChange={this.handleChange}
                onSelect={this.handleSelect}
                value={this.state.valueText}
                open={readOnly ? false : this.state.open}
                inputProps={{
                    label: label,
                    readOnly: readOnly,
                    // helperText: this.state.duration,
                    fullWidth: true,
                    id: this.props.id
                }}
                wrapperStyle={{
                    ...this.props.wrapperStyle,
                    display: "inline-block",
                    position: "relative",
                    width: "100%"
                }}
            />
            /* // <TextField
            //     label={label}
            //     value={value}
            //     margin={margin ? margin : "dense"}
            //     fullWidth
            //     error={this.props.error}
            //     helperText={this.props.helperText}
            //     // InputProps={{
            //     //     inputComponent: TimePicker,
            //     //     readOnly: readOnly,
            //     //     inputProps: {
            //     //         open: this.state.timepickerOpen,
            //     //         onOpen: this.setOpen,
            //     //         onClose: this.setOpen,
            //     //         showSecond: false,
            //     //         onChange: this.handleChange,
            //     //         popupClassName: "time-picker",
            //     //         focusOnOpen: true,
            //     //         allowEmpty: false,
            //     //         disabledHours: this.calculateDisabledHour,
            //     //         disabledMinutes: this.calculateDisabledMinute
            //     //     },
            //     //     endAdornment: (
            //     //         <InputAdornment position="start" style={{ padding: 0, backgroundColor: "transparent" }}>
            //     //             <IconButton onClick={this.handleToggleOpen}>
            //     //                 <AlarmIcon />
            //     //             </IconButton>
            //     //         </InputAdornment>
            //     //     )
            //     // }}
            // /> */
        );
    }
}

export default HubTimepicker;
